import React, { PropsWithChildren } from "react";
import { Box } from "./AHTheme/Box";
import { AHText } from "./Text";
import { ColorType } from "./AHTheme/AHTheme";
import { Circle } from "./AHTheme/Circle";
import { AHIcon } from "./AHIcon";

export function SectionHeader(
  props: PropsWithChildren<{
    color?: ColorType;
    left?: React.ReactNode;
    right?: React.ReactNode;
  }>
) {
  return (
    <Box
      style={{
        flexDirection: "row",
      }}
      spaceLeft="medium"
      color={props.color}
    >
      {props.left ? (
        <Box
          spaceRight="medium"
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {props.left}
        </Box>
      ) : null}
      <Box
        spaceVertical="small"
        style={{
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {props.children}
      </Box>
      {props.right ? (
        <Box
          spaceLeft="medium"
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {props.right}
        </Box>
      ) : null}
    </Box>
  );
}

function SectionHeaderTitle(props: PropsWithChildren<object>) {
  return (
    <AHText type="title-small" style={{ flex: 1, flexDirection: "row" }}>
      {props.children}
    </AHText>
  );
}

function SectionHeaderDescription(props: PropsWithChildren<object>) {
  return (
    <AHText
      type="body"
      style={{ lineHeight: 17 }}
      color="text-secondary"
      spaceVertical="xxsmall"
    >
      {props.children}
    </AHText>
  );
}

function SectionHeaderAdd() {
  return (
    <Circle size="smallMedium" style={{ borderWidth: 1 }} borderColor="primary">
      <AHIcon type="add" size="body" color="primary" />
    </Circle>
  );
}

SectionHeader.Title = SectionHeaderTitle;
SectionHeader.Description = SectionHeaderDescription;
SectionHeader.Add = SectionHeaderAdd;
